import React, {forwardRef, useEffect, useImperativeHandle, useRef} from "react";
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";
import InputLabel from "@material-ui/core/InputLabel";
import constants from "../../constants";
import {BORDER_RADIUS} from "src/styles/Styles";
import {FormattedMessage} from "react-intl";
import FormHelperText from "@material-ui/core/FormHelperText";
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {ColorTheme, ColorTitle, ColorWhite} from "src/styles/Colors";
import {IconButton, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import Utils from "../../utils/utils";
import MyLocationIcon from '@material-ui/icons/MyLocation';
import LocationHelper, {LOCATION_TIMEOUT} from "../../utils/LocationHelper";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CircularProgress from "@material-ui/core/CircularProgress";
import {SNACKBAR_AUTO_HIDE_DURATION} from "src/js/components/commons/ViewHelper";

const { SearchBox } = require("react-google-maps/lib/components/places/SearchBox");

export const DEFAULT_LATITUDE = 24.7136;
export const DEFAULT_LONGITUDE = 46.6753;
export const ZOOM_NO_LOCATION = 8;
export const ZOOM_COARSE_LOCATION = 16;

const ZOOM_NO_LOCATION_RADIUS = 222177.64634107583;
const ZOOM_LOCATION_RADIUS = 867.9510218664193;
const COLOR_LOCATION_HIGHLIGHT = ColorTheme;
const COLOR_RADIUS_HIGHLIGHT = ColorTheme;
export const MAP_EXTRA_HEIGHT = 100;

export default class MapField extends React.Component {

  constructor(props) {
    super(props);
    let {center, radius, disabled} = props;
    this.cLocation = LocationHelper.getPastLocation();
    const maxWidth = props.width || 400;
    const maxHeight = props.height || (maxWidth + MAP_EXTRA_HEIGHT);
    this.maxHeight = maxHeight;

    let zoom = ZOOM_NO_LOCATION;
    if (!center) {
      if (this.cLocation) {
        center = {lat: this.cLocation.latitude, lng: this.cLocation.longitude};
      } else {
        center = {lat: DEFAULT_LATITUDE, lng: DEFAULT_LONGITUDE};
      }
    } else {
      zoom = ZOOM_COARSE_LOCATION;
    }
    if (props.radiusNeeded) {
      zoom = this.processZoomForRadius(zoom, center, radius);
      if (!radius) {
        radius = zoom;
      }
    }
    this.state = {
      zoom: zoom,
      center: center,
      radius: radius,
      defaultCenter: center,
      disabled: disabled || false,
      locationInProgress: false
    }
    this.refMap = null;
  }

  componentDidMount() {
    this.processCenterOrZoomChanged();
  }

  componentWillUnmount() {
    this.refMap = null;
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.readOnly && (this.props.center.lat != nextProps.center.lat || this.props.center.lng != nextProps.center.lng || this.props.radius != nextProps.radius)) {
      let zoom = this.state.zoom;
      if (nextProps.radius) {
        zoom = this.processZoomForRadius(zoom, nextProps.center, nextProps.radius);
      }
      this.setState({center: nextProps.center, radius: nextProps.radius, zoom: zoom});
    }
  }

  processZoomForRadius(zoom, center, radius) {
    if (center && radius) {
      return parseInt(Math.log(156543.03392 * (this.maxHeight-MAP_EXTRA_HEIGHT) * Math.cos(center.lat * Math.PI / 180) / radius) / Math.log(2));
    }
    return zoom;
  }

  render() {
    const {classes, label, hintLabel, radiusNeeded, isLTR, styleMapContainer} = this.props;
    const {defaultCenter, center, zoom, radius, disabled, locationInProgress} = this.state;
    let eRadius = radius;
    if (radiusNeeded && eRadius) {
      let decimalUpto = 1;
      if (eRadius >= 1000) {
        eRadius /= 1000;
        decimalUpto = 0;
      }
      eRadius = eRadius.toFixed(decimalUpto);
    }
    return (
      <div className={classes.viewColumnFullWidthNoCenter}>
        <div className={classes.mapContainer} style={styleMapContainer}>
          {!disabled ?
            <div style={{position: 'relative', paddingBottom: 2, marginTop: label != null ? 8 : 0}}>
              <GoogleMapView
                context={this.context}
                refMap={ref => this.refMap = ref}
                refSearch={ref => this.refSearch = ref}
                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${constants.googleMapApiKey}&libraries=places&callback=Function.prototype`}
                containerElement={<div style={{width: '100%', height: this.maxHeight, borderRadius: BORDER_RADIUS, border: `1px solid rgba(0,0,0,0.1)`}} />}
                mapElement={<div style={{width: '100%', height: '100%', borderRadius: BORDER_RADIUS}} />}
                loadingElement={<div style={{width: '100%', height: '100%', borderRadius: BORDER_RADIUS}} />}
                readOnly={this.props.readOnly}
                classes={classes}
                defaultCenter={defaultCenter}
                radius={eRadius}
                center={center}
                defaultZoom={zoom}
                zoom={zoom}
                markers={this.props.markers}
                noPadding={label == null}
                onClickMap={this.onClickMap}
                onDragEnd={this.onDragEnd}
                onZoomChanged={this.onZoomChanged}
                onMarkerDragEnd={this.onMarkerDragEnd}
                onPlacesChanged={this.onPlacesChanged}
                isLTR={isLTR}
                isLocationPresent={LocationHelper.isLocationPresent()}
                locationInProgress={locationInProgress}
                onCurrentLocationClicked={this.onCurrentLocationClicked}>
              </GoogleMapView>
              {!this.props.readOnly ?
                <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute',
                  top: 0, left: 0, right: 0, bottom: 0, height: this.maxHeight, pointerEvents: 'none'}}>
                  <div className={classes.viewColumnFullWidth}>
                    {!this.props.readOnly ? <FormHelperText style={{backgroundColor: COLOR_LOCATION_HIGHLIGHT, color: ColorWhite, fontWeight: 'bold', borderRadius: 4, paddingLeft: 4, paddingRight: 4, marginBottom: 4}}><FormattedMessage id={'activity.manage.moveMapToAdjust'} /></FormHelperText> : null}
                    <LocationOnIcon style={{fontSize: 50, marginBottom: this.props.readOnly ? 40 : 70, color: COLOR_LOCATION_HIGHLIGHT}}/>
                  </div>
                  {this.props.radiusNeeded ?
                    <div style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <div style={{width: this.maxHeight-MAP_EXTRA_HEIGHT, height: this.maxHeight-MAP_EXTRA_HEIGHT, borderRadius: (this.maxHeight-MAP_EXTRA_HEIGHT)/2, border: '1px solid '+ Utils.colorWithAlpha(COLOR_RADIUS_HIGHLIGHT, 0.3) , backgroundColor: Utils.colorWithAlpha(COLOR_RADIUS_HIGHLIGHT, 0.05)}} />
                    </div>
                    : null
                  }
                  {center ?
                    <div style={{position: 'absolute', bottom: this.props.readOnly ? 20 : 46, left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                      <Typography variant={'body2'} style={{backgroundColor: COLOR_LOCATION_HIGHLIGHT, color: ColorWhite, fontWeight: 'bold', borderRadius: 4, paddingLeft: 4, paddingRight: 4, marginBottom: 4}}>{center.lat.toFixed(6) +', '+ center.lng.toFixed(6)}</Typography>
                      {this.props.radiusNeeded ?
                        <Typography variant={'body2'} style={{backgroundColor: COLOR_LOCATION_HIGHLIGHT, color: ColorWhite, fontWeight: 'bold', borderRadius: 4, paddingLeft: 4, paddingRight: 4, marginBottom: 4, marginTop: -2}}><FormattedMessage id={radius >= 1000 ? 'activity.manage.mapRadiusKms' : 'activity.manage.mapRadiusMeter'} values={{value: eRadius}} /></Typography>
                        : null
                      }
                    </div>
                    : null
                  }
                </div>
                : null
              }
            </div>
            : null
          }
        </div>
        {this.renderSnackBar()}
      </div>
    );
  }

  renderSnackBar() {
    const {showSnackbar, snackbarInfo} = this.state;
    if (showSnackbar) {
      const {messageId, message, type} = snackbarInfo;
      return (
        <Snackbar open={messageId || message} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION} onClose={this.onCloseSnackbar}>
          <MuiAlert severity={type || "success"} onClose={this.onCloseSnackbar} elevation={6} variant="filled" style={{borderRadius: BORDER_RADIUS}}>
            {messageId ? <FormattedMessage id={messageId}/> : null}
            {message}
          </MuiAlert>
        </Snackbar>
      );
    }
  }

  showSnackbar(snackbarInfo) {
    if (snackbarInfo) {
      this.setState({showSnackbar: true, snackbarInfo});
    }
  }

  onCloseSnackbar = () => {
    this.setState({showSnackbar: false, snackbarInfo: null});
  }

  onToggle = () => {
    const zoom = ZOOM_NO_LOCATION;
    const center = {lat: DEFAULT_LATITUDE, lng: DEFAULT_LONGITUDE};
    const radius = zoom === ZOOM_NO_LOCATION ? ZOOM_NO_LOCATION_RADIUS : ZOOM_LOCATION_RADIUS;
    this.setState({disabled: !this.state.disabled, center: center, zoom: zoom, radius: radius}, () => {
      this.processCenterOrZoomChanged();
    });
  };

  onClickMap = (event) => {
    const newCenter = {lat: event.latLng.lat(), lng: event.latLng.lng()};
    this.setState({center: newCenter}, () => {
      this.processCenterOrZoomChanged();
    });
  };

  onMarkerDragEnd = (event) => {
    // const latitude = event.latLng.lat();
    // const longitude = event.latLng.lng();
    // this.setState({
    //   latitude: latitude,
    //   longitude: longitude,
    // });
  };

  onDragEnd = () => {
    this.processCenterOrZoomChanged();
  };

  onZoomChanged = () => {
    this.processCenterOrZoomChanged();
  };

  onPlacesChanged = () => {
    if (this.refSearch) {
      const places = this.refSearch.getPlaces();
      const nextMarkers = places.map(place => ({
        position: place.geometry.location,
      }));
      if (nextMarkers && nextMarkers.length > 0) {
        const nextCenter = nextMarkers[0].position;
        const newCenter = {lat: nextCenter.lat(), lng: nextCenter.lng()};
        this.setState({center: newCenter}, () => {
          this.processCenterOrZoomChanged();
        });
      }
    }
  };

  onCurrentLocationClicked = () => {
    this.setState({locationInProgress: true});
    LocationHelper.getLocation((location) => {
      this.cLocation = location;
      this.setState({locationInProgress: false, center: {lat: this.cLocation.latitude, lng: this.cLocation.longitude}, zoom: ZOOM_COARSE_LOCATION}, () => {
        this.processCenterOrZoomChanged();
      });
      this.showSnackbar({
        messageId: 'location.mapMovedToCurrentLocation',
      });
    }, (errorCode) => {
      this.setState({locationInProgress: false});
      let messageId = null;
      if (errorCode === LOCATION_TIMEOUT) {
        messageId = 'location.locationTimeout';
      } else {
        messageId = 'location.locationDenied';
      }
      this.showSnackbar({
        messageId: messageId,
        type: 'error'
      });
    });
  };

  processCenterOrZoomChanged() {
    let {center, zoom} = this.state;
    if (this.refMap) {
      const newCenter = this.refMap.getCenter();
      center.lat = newCenter.lat();
      center.lng = newCenter.lng();
      zoom = this.refMap.getZoom();
    }
    let radius = 0;
    if (this.props.radiusNeeded) {
      radius = 156543.03392 * Math.cos(center.lat * Math.PI / 180) / Math.pow(2, zoom) * (this.maxHeight-MAP_EXTRA_HEIGHT);
      this.setState({radius});
    }

    if (!this.state.disabled) {
      this.props.onCenterChanged({center: center, zoom: zoom, radius: radius});
    } else {
      this.props.onCenterChanged();
    }
  }
}

MapField.contextTypes = {
  intl:PropTypes.object.isRequired
}

const GoogleMapView = withScriptjs(withGoogleMap(forwardRef((props, ref) => {
  const {refMap, classes, markers, radius, readOnly, label, noPadding, context, isLTR, locationInProgress, isLocationPresent, onCurrentLocationClicked} = props;

  const mapRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getCenter, getZoom
  }));

  const getCenter = () => {
    alert('hello');
    // return mapRef.current.getCenter();
  }
  const getZoom = () => {
    alert('zello');
    // return mapRef.current.getZoom();
  }

  // Fit bounds function
  const fitBounds = () => {
    if (markers && markers.length > 0 && !radius) {
      const bounds = new window.google.maps.LatLngBounds();
      markers.map(item => {
        bounds.extend(item.position);
        return item.id
      });
      mapRef.current.fitBounds(bounds);
    }
  };

  // Fit bounds on mount, and when the markers change
  useEffect(() => {
    fitBounds();
  }, [markers, ref]);

  return (
    <div className={classes.mapContainer} style={{padding: noPadding ? 0 : 8}}>
      {label ?
        <div style={{padding: 10, paddingTop: 6, paddingBottom: 0, marginBottom: -6}}>
          <InputLabel>{label}</InputLabel>
        </div>
        : null
      }
      <GoogleMap
        // ref={props.refMap}
        ref={(element) => {
          mapRef.current = element;
          if (refMap) {
            refMap(element);
          }
        }}
        // ref={mapRef}
        draggable={false}
        options={{
          streetViewControl: false,
          fullscreenControl: false,
          // fullscreenControlOptions: {
          //   position: google.maps.ControlPosition.BOTTOM_RIGHT,
          // },
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.BOTTOM_LEFT,
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID],
          }
        }}
        mapTypeId={google.maps.MapTypeId.HYBRID}
        defaultCenter={props.defaultCenter}
        center={props.center}
        defaultZoom={props.defaultZoom}
        zoom={props.zoom}
        onClick={props.onClickMap}
        onDragEnd={props.onDragEnd}
        onZoomChanged={props.onZoomChanged}>
        {!readOnly ?
          <SearchBox
            ref={props.refSearch}
            bounds={props.bounds}
            controlPosition={google.maps.ControlPosition.TOP_CENTER}
            onPlacesChanged={props.onPlacesChanged}>
            <div style={{width: '100%', padding: 6, display: 'flex', flexDirection: 'row'}}>
              <input
                disabled
                type="text"
                placeholder={context.intl.formatMessage({id: 'map.searchPlace'})}
                style={{
                  boxSizing: `border-box`,
                  border: `1px solid transparent`,
                  width: '100%',
                  height: 40,
                  padding: `0 12px`,
                  borderRadius: 3,
                  boxShadow: `0 2px 2px rgba(0, 0, 0, 0.1)`,
                  fontSize: 16,
                  outline: `none`,
                  textOverflow: `ellipses`,
                  opacity: 0,
                }}
              />
              {isLocationPresent ?
                <IconButton
                  disabled={locationInProgress}
                  onClick={onCurrentLocationClicked}
                  style={{
                    boxSizing: `border-box`,
                    border: `1px solid transparent`,
                    width: 40,
                    height: 40,
                    marginLeft: isLTR ? 8 : 0,
                    marginRight: isLTR ? 0 : 8,
                    // padding: `0 12px`,
                    borderRadius: 3,
                    boxShadow: `0 2px 2px rgba(0, 0, 0, 0.1)`,
                    outline: `none`,
                    textOverflow: `ellipses`,
                    backgroundColor: '#FFF',
                    color: ColorTitle,
                    position: 'relative'
                  }}>
                  {locationInProgress ?
                    <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <CircularProgress size={20}  />
                    </div>
                    : <MyLocationIcon/>
                  }
                </IconButton>
                : null
              }
            </div>
          </SearchBox>
          : null
        }
        {props.markers && props.markers.length > 0 ?
          props.markers.map((marker) => {
            return <Marker
              draggable={false}
              label={marker.label}
              title={marker.name}
              position={marker.position}
              onDragEnd={props.onMarkerDragEnd}
            />
          })
          : null
        }
      </GoogleMap>
    </div>
  )
})));
